import { Component, ViewEncapsulation } from '@angular/core';
import { MemberInformationService } from '../member-information.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { ActivatedRoute } from '@angular/router';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { CommonLibrary } from '../../../core/common-library';
import { ResourcePageDetails } from '../DTOs/resource-page-details';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-resource-details',
  templateUrl: './resource-details.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ResourcePageDetailsComponent {

    constructor(private memberInformationService: MemberInformationService
        , private blockUI: UIBlockingService
        , private route: ActivatedRoute
        , private notificationService: ToastNotificationService
        , private sanitizer: DomSanitizer) {
    }
    protected readonly CommonLibrary = CommonLibrary;
    pageId: string;
    resourcePage: ResourcePageDetails = new ResourcePageDetails();
    safePageContent: SafeHtml;

    ngOnInit() {
        this.pageId = this.route.snapshot.paramMap.get("pageId");

        this.blockUI.start();
        
        this.getResourcePageDetails();
    }


    getResourcePageDetails() {
        this.blockUI.start();
        this.memberInformationService.GetResourcePageDetails(this.pageId)
            .subscribe(
                {
                    next: (data) => {
                        this.resourcePage = data;
                        this.safePageContent = this.sanitizer.bypassSecurityTrustHtml(data.pageContent);
                        this.blockUI.stop();
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    DownloadAttachment(ind) {
        CommonLibrary.downloadImageByUrl(this.resourcePage.attachments[ind].downloadUrl, this.resourcePage.attachments[ind].name.split('.')[0])
    }
}
